/* Every filled segment takes the current level's colour, so the bar shifts hue as
   it fills: weak → red/rose, medium → amber, strong → green (a fully strong password
   shows an all-green bar). Values mirror the legacy admin.less strength strip, except
   the grey "medium" — swapped for amber, which reads as caution rather than "empty".
   Exposed as a custom property so a future token bridge can retheme without touching
   this file. */
.root {
	--pw-track: var(--password-strength-track);
	--pw-color: var(--pw-track); /* overridden per level below */

	display: block;
}

.track {
	display: flex;
	gap: 5px;
}

.segment {
	flex: 1 1 0;
	height: 4px;
	border-radius: 2px;
	background-color: var(--pw-track);
	transition: background-color 0.25s ease-in-out;
}

.segment[data-active] {
	background-color: var(--pw-color);
}

/*
* Derived from the old meter
* Coming from admin.less .password-strength-indication-item-*
*/
.root[data-level="very-weak"] {
	--pw-color: #ff0000;
}

.root[data-level="weak"] {
	--pw-color: #f1828d;
}

.root[data-level="medium"] {
	--pw-color: #f0ad4e;
}

.root[data-level="strong"] {
	--pw-color: #87d37c;
}

.root[data-level="very-strong"] {
	--pw-color: #66bb6a;
}

.label {
	margin-top: 6px;
	font-size: 12px;
	line-height: 15px;
	color: var(--password-strength-label);
}
